/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ProcessStatusGroup {

        public processStatusGroupDto: Wars.Domain.Model.Dtos.Workflow.StatusDto; 
        public workflowBlocks: IWorkflowBlock[];

        public constructor() {
            this.processStatusGroupDto = <any>{
                id: undefined,
                isInitialStatus: false,
                statusName: "",
                statusDescription: "",
                workflowBlocks: []
            }
        }

        public intitialize(processStatusGroup: Wars.Domain.Model.Dtos.Workflow.StatusDto, workflowBlocks: IWorkflowBlock[]) : void {
            this.processStatusGroupDto = processStatusGroup;
            this.workflowBlocks = workflowBlocks;
        }

        public getInitialBlock(): IWorkflowBlock {
            if (!this.workflowBlocks || this.workflowBlocks.length === 0) return undefined;
            return Enumerable.from(this.workflowBlocks).singleOrDefault(i => i.isInitialBlock);
        }
    }
}